import { render, staticRenderFns } from "./question-modal.vue?vue&type=template&id=2eb42049"
import script from "./question-modal.vue?vue&type=script&lang=js"
export * from "./question-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports